/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {ASSET_ERROR} from '../resources-constants';
import {ApiConfig} from '../../api';
import {AdnHttpProgressCallback, AdnHttpService} from '../../../util/adn-http.service';
import {
  createAdnHttpResource,
  createAdnHttpResourceSender,
  createAdnHttpUploadSender,
  createAdnUploadFormData
} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the ContextServiceConfiguration HTTP resource (factory product). */
export class ContextServiceConfigurationResource {
}

export function createContextServiceConfigurationResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  return createAdnHttpResource(send, 'contextserviceconfigurations', () => localUserProfile, 'contextServiceConfiguration');
}

export const contextServiceConfigurationResourceProvider = {
  provide: ContextServiceConfigurationResource,
  useFactory: createContextServiceConfigurationResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

@Injectable({
  providedIn: 'root'
})
export class ContextServiceKeywordUploadService {
  private readonly sendUpload: (config: any, onProgress?: AdnHttpProgressCallback) => any;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.sendUpload = createAdnHttpUploadSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  upload(data: any, uploadType: any, resourceId: any, onProgress?: AdnHttpProgressCallback): any {
    if (!data || !(data.file || data.content)) {
      return Promise.reject(ASSET_ERROR.NO_FILE);
    }
    return this.sendUpload({
      method: 'POST',
      url: ApiConfig.obtain().getVersionedUri(['contextserviceconfigurations', resourceId, 'keywords']),
      body: createAdnUploadFormData(data)
    }, onProgress);
  }
}
